<template>
  <div>
    <lk-modal v-model="replaceModal" title="编辑图片" width='550' :closable="false"  :mask-closable="false">
      <div class="modelContent">
        <lk-form
          :label-width='120'
          label-position="right"
        >
          <lk-row>
            <lk-col>
              <lk-form-item label='上传新的处方图片:'>
                <Uploader style="width:250px" :able='true' v-model="imgUrl"></Uploader>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </div>
      <div slot="footer">
        <lk-button @click="handlerCancel">取消</lk-button>
        <lk-button :loading='confirmReceivedLoading' @click="confirmReceived" type='primary'>确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import Uploader from '../Uploader.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';

export default {
  components: {
    Uploader,
  },
  props: {
    newCurrentList: {
      type: Array,
    },
    replaceModal: {
      type: Boolean,
      default: false,
    },
    currentImg: {
      type: String,
    },
    epId: {
      type: Number,
    },
  },
  model: {
    prop: 'newCurrentList',
    event: 'change',
  },
  data() {
    return {
      confirmReceivedLoading: false,
      imgUrl: '',
    };
  },
  computed: { },
  watch: { },
  methods: {
    handlerCancel() {
      this.$emit('update:replaceModal', false);
      this.imgUrl = '';
    },
    confirmReceived() {
      if (this.imgUrl == '') {
        this.$Message.error('请选择图片');
        return;
      }
      const params = {
        epId: this.epId,
        oldPicUrl: encodeURIComponent(this.currentImg),
        newPicUrl: this.imgUrl,
      };
      sale.prescriptionReplacePic( params ).then((res) => {
        if (res.data.status === 200) {
          const imgList = [];
          res.data.data.forEach((item) => {
            imgList.push(decodeURIComponent(item));
          });
          this.$emit('change', imgList);
          this.$emit('update:replaceModal', false);
          this.$emit('update:currentImg', decodeURIComponent(this.imgUrl));
          this.imgUrl = '';
        } else {
          this.$Message.error(res.data.error);
        }
        this.confirmReceivedLoading = false;
      }).catch((err) => {
        this.confirmReceivedLoading = false;
        utils.handleError(err);
      });
    },
  },
  mounted() { },
};
</script>
<style lang="less" >
</style>
